export interface AppointmentRequestCompanySummary {
  id: string;
  name: string;
}

interface AppointmentRequestDepartment {
  id: string;
  name: string;
  company_subject?: AppointmentRequestCompanySummary;
}

export interface AppointmentRequestDepartmentOption {
  value: string;
  label: string;
  companySubjectId?: string;
}

export interface AppointmentRequestDepartmentGroup {
  label: string;
  companySubjectId: string;
  options: AppointmentRequestDepartmentOption[];
}

export const getFlatAppointmentRequestDepartmentOptions = (
  departments: AppointmentRequestDepartment[],
): AppointmentRequestDepartmentOption[] =>
  departments
    .map((department) => ({
      value: department.id,
      label: department.name,
    }))
    .sort((a, b) => a.label.localeCompare(b.label));

export const groupAppointmentRequestDepartments = (
  departments: AppointmentRequestDepartment[],
): AppointmentRequestDepartmentGroup[] => {
  const groups = new Map<string, AppointmentRequestDepartmentGroup>();

  departments.forEach((department) => {
    const companyName = department.company_subject?.name;
    const companySubjectId = department.company_subject?.id;

    if (!companyName || !companySubjectId) return;

    if (!groups.has(companySubjectId)) {
      groups.set(companySubjectId, {
        label: companyName,
        companySubjectId,
        options: [],
      });
    }

    groups.get(companySubjectId)?.options.push({
      value: department.id,
      companySubjectId,
      label: `${department.name} - ${companyName}`,
    });
  });

  return Array.from(groups.values());
};
